export function plural(
  n: number,
  one: string,
  options: { many?: string; format?: (n: number) => string } = {},
): string {
  return `${(options.format ?? String)(n)} ${n === 1 ? one : (options.many ?? `${one}s`)}`;
}
